import React,{useEffect,useContext, useRef, useState} from 'react';
import { NavLink, Link, useLoaderData, useLocation} from "react-router-dom";
import ProgressiveImage from './ProgressiveImage/BackgroundImage';
import ProgressiveImageImg from './ProgressiveImage/FirstSlider';
import { ThemeContext } from '../context/ThemeContext';
import { useSwiper, Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Pagination, Navigation, Autoplay } from 'swiper/modules';
import ColoredScrollbars from './ColoredScrollbars';
import { useHashScroll } from '../hooks/useHashScroll';
import TitleAnimated from './TitleAnimated';
import TitleAnimatedRotated from './TitleAnimatedRotated';
import ServicesHome from './ServicesHome';
import Contact from './Contact';
import SEO from './SEO';
import { generateOrganizationSchema, generateWebsiteSchema } from '../utils/structuredData';

//import MinimalScrollTop from './MinimalScrollTop';
import 'swiper/css';
import 'swiper/css/virtual';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';



function Home(props) {

  const [swiperRef, setSwiperRef] = useState(null);
  const [imgHeight, setImgHeight] = useState(100);
  const [typeWriterScale, setTypeWriterScale] = useState(2);
  const [currentHash, setCurrentHash] = useState('');
  const [currentSlideTitle, setCurrentSlideTitle] = useState(''); // Add state for current title
  const [soundEnabled, setSoundEnabled] = useState(false); // Add sound toggle state
  const scrollRef_1 = useRef(null);
  const scrollRef_2 = useRef(null);

  const titleRef = useRef();



  ////console.log(props);
  let projectsData = useLoaderData();
  let videosData = projectsData.items['videosFeat'];
  let projectsCatFeat = projectsData.items['catFeat'];
  let projectsCat = projectsData.items['cat'];
  let projectsLaunch = projectsData.items['launch'];
  let news = projectsData.items['news'];
    let about = projectsData.items['about'];
  ////console.log(projectsData.items);

  const shuffledProjects = [...projectsCatFeat].sort(() => Math.random() - 0.5);

  // Define video data array with titles
  /*const videosData = [
    {
      src: 'https://player.vimeo.com/progressive_redirect/playback/1108165205/rendition/1080p/file.mp4?loc=external&log_user=0&signature=5ad33103ff46ef84937425d1676c993a963a288ade19f23ab4420f5fccda05d9',
      logo: 'https://discover.af-pictures.com/storage/app/media/proyectos/fragmentos/fragmentos-logo.png',
      title: 'Próximamente en Cine',
      slug: '/catalogo/fragmentos',

    },
    {
      src: 'https://player.vimeo.com/progressive_redirect/playback/1108165247/rendition/540p/file.mp4?loc=external&log_user=0&signature=a891a0b066ea532a2bea14066f357599e6323affbd74f1eac0d59957c4f0e24d',
      logo: 'https://discover.af-pictures.com/storage/app/media/proyectos/evil-dress/evil-dress-type.png',
      title: 'Disponible en movistar+',
      url: '/catalogo/evil-dress',
    },
    {
      src: 'https://player.vimeo.com/progressive_redirect/playback/1108165171/rendition/1080p/file.mp4?loc=external&log_user=0&signature=31aafec1ad61c73a5db3dd79bfe8f3ae1901b93a6db7c912ad342e58a36d08ac',
      logo: 'https://discover.af-pictures.com/storage/app/uploads/public/4e2/397/6fc/thumb__0_600_0_0_crop.png',
      title: 'Ya en Digital',
      url: '/catalogo/proyecto-tres',
    }
  ];*/

  const theme = useContext(ThemeContext);
////console.log(theme.state);

const location = useLocation();

useEffect(() => {
if (location.hash) {
  setTimeout(() => {
    const element = document.querySelector(location.hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, 100); // small delay to allow DOM render
}
}, [location]);

useEffect(()=> {
  // force 100% height
  if(theme.state.vertical && imgHeight != 80 ){
  setImgHeight(80);
  setTypeWriterScale(1.8);
  ////console.log('switching vert.')
  }
},[theme.state.vertical])

// Function to update title with animation
const updateTitleWithAnimation = (newTitle) => {
  const titleElement = document.getElementById('ttlRotate');
  if (titleElement) {
    // Fade out
    titleElement.style.opacity = '0';
    titleElement.style.transform = 'translateY(-50px)';

    setTimeout(() => {
      // Change text
      titleElement.textContent = newTitle;
      setCurrentSlideTitle(newTitle);

      // Fade in
      titleElement.style.opacity = '1';
      titleElement.style.transform = 'translateY(-60px)';
    }, 300); // Half of transition duration
  }
};

// Function to gradually increase volume (much slower - 4 seconds) - REMOVED soundEnabled check
const gradualVolumeIncrease = (video, targetVolume = 0.3, duration = 4000) => {
  if (!video) {
    ////console.log('No video provided to gradualVolumeIncrease');
    return;
  }

  ////console.log('Starting gradual volume increase to', targetVolume);

  const startVolume = 0;
  const volumeStep = targetVolume / (duration / 100); // 100ms intervals
  let currentVolume = startVolume;

  video.muted = false;
  video.volume = 0;

  const volumeInterval = setInterval(() => {
    if (currentVolume < targetVolume) {
      currentVolume += volumeStep;
      video.volume = Math.min(currentVolume, targetVolume);
      ////console.log('Volume:', video.volume);
    } else {
      video.volume = targetVolume; // Ensure we hit exact target
      ////console.log('Volume increase complete:', video.volume);
      clearInterval(volumeInterval);
    }
  }, 100); // Update every 100ms for smooth transition

  // Cleanup if video ends or is paused
  const cleanup = () => {
    ////console.log('Cleaning up volume interval');
    clearInterval(volumeInterval);
  };
  video.addEventListener('pause', cleanup, { once: true });
  video.addEventListener('ended', cleanup, { once: true });
};

// Sound toggle function
const toggleSound = () => {
  const newSoundState = !soundEnabled;
  setSoundEnabled(newSoundState);

  ////console.log('Toggling sound to:', newSoundState);

  // Apply to currently playing video - try multiple selectors
  let activeVideo = document.querySelector('.swiper-slide-active video');
  if (!activeVideo) {
    activeVideo = document.querySelector('.swiper-slide video');
  }
  if (!activeVideo) {
    activeVideo = document.querySelector('video');
  }

  ////console.log('Found video:', activeVideo);
  ////console.log('Video paused?', activeVideo ? activeVideo.paused : 'N/A');
  ////console.log('Video muted?', activeVideo ? activeVideo.muted : 'N/A');

  if (activeVideo) {
    if (newSoundState) {
      // Enabling sound
      //console.log('Enabling sound on video');

      // Ensure video is playing before trying to add sound
      if (activeVideo.paused) {
        //console.log('Video is paused, trying to restart...');
        activeVideo.play().then(() => {
          gradualVolumeIncrease(activeVideo, 0.3, 4000);
        }).catch(e => {
          //console.log('Failed to restart video for sound:', e);
          // Try anyway in case video is loaded
          gradualVolumeIncrease(activeVideo, 0.3, 4000);
        });
      } else {
        // Video already playing, just add sound
        //console.log('Video is playing, adding sound...');
        gradualVolumeIncrease(activeVideo, 0.3, 4000);
      }
    } else {
      // Disabling sound - don't pause, just mute
      //console.log('Disabling sound on video');
      activeVideo.muted = true;
      activeVideo.volume = 0;
    }
  } else {
    //console.log('No video found to toggle sound');
  }
};

  // Generate structured data for homepage
  const organizationSchema = generateOrganizationSchema();
  const websiteSchema = generateWebsiteSchema();
  const combinedSchema = [organizationSchema, websiteSchema];

  return (
    <>
      <SEO
        title="AF Pictures - Distribución cinematográfica profesional"
        description="Empresa líder en distribución cinematográfica. Especialistas en la promoción y distribución de películas independientes, largometrajes y cortometrajes."
        keywords="distribución cinematográfica, distribuidora de cine, películas independientes, distribución de largometrajes, cine español, distribución audiovisual, AF Pictures"
        url="https://afpictures.com"
        image="https://afpictures.com/img/af-pictures-og.jpg"
        structuredData={combinedSchema}
      />

      {/* Sound Toggle Button */}
      <button style={{marginTop:'5px',marginRight:'6px'}}
        onClick={toggleSound}
        className="fixed top-16 md:top-6 right-4 z-10 bg-black bg-opacity-20 hover:bg-opacity-70 text-white p-3 rounded-full transition-all duration-300"
        aria-label={soundEnabled ? "Mute audio" : "Enable audio"}
      >
        {soundEnabled ? (
          // Volume On Icon
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
          </svg>
        ) : (
          // Volume Off Icon
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
          </svg>
        )}
      </button>



      <section className={"pt-0 " + props.transition}>
<div className="relative">
<Swiper
      onSwiper={setSwiperRef}
      className="mySwiper"

      modules={[Pagination, Navigation, EffectFade, Autoplay]}
      spaceBetween={0}
      centeredSlides={true}
      speed={800}
      //initialSlide={projectsCatFeat.length}
       /* autoplay={{
          delay: 4000,
          disableOnInteraction: true,
        }}*/
        //waitForTransition
        pagination={{
          clickable: true,
        }}
      loop={true}
      slidesPerView={1}
      effect={'fade'}
      navigation={true}
      allowSlideNext={true}
      allowSlidePrev={true}
      simulateTouch={true}
      touchRatio={1}
      touchAngle={45}
      grabCursor={false}
      allowTouchMove={true}
      noSwiping={false}
      noSwipingClass="swiper-no-swiping"
      onInit={(swiper) => {
         swiper.el.querySelectorAll('.project-logo').forEach((logo, index) => {
           if (index !== 0) {
             logo.style.opacity = '0';
             logo.style.visibility = 'hidden';
           }
         });
        }}
      onSlideChange={(swiper) => {
        // Get the real index (accounting for loop mode)
        const realIndex = swiper.realIndex;

        // Update title based on current slide
        if (videosData[realIndex] && videosData[realIndex].video_headline) {
          updateTitleWithAnimation(videosData[realIndex].video_headline);
        }

        swiper.slides[swiper.activeIndex].classList.remove('opacity-0');
        swiper.slides[swiper.activeIndex].classList.add('opacity-100');

      // Pause all videos first and reset sound
  swiper.el.querySelectorAll('video').forEach((video) => {
    video.pause();
    video.currentTime = 0;
    video.muted = true;
    video.volume = 0;
  });

  // Play video in active slide if it's a video slide (first 3 slides)
  if (swiper.activeIndex < 3) {
    const activeSlideEl = swiper.slides[swiper.activeIndex];
    const activeVideo = activeSlideEl.querySelector('video');
    if (activeVideo) {
      activeVideo.play().then(() => {
        // Only apply sound if sound is enabled
        if (soundEnabled) {
          gradualVolumeIncrease(activeVideo, 0.3, 4000);
        }
      }).catch(e => console.log('Video play failed:', e));
    }
  }

        // Hide all logos
      swiper.el.querySelectorAll('.project-logo').forEach((logo) => {
        logo.classList.remove('opacity-100', 'pr-6');
        logo.classList.add('opacity-0', 'pr-0');
      });

      // Reveal the active one
      const activeSlideEl = swiper.slides[swiper.activeIndex];
      const activeLogo = activeSlideEl.querySelector('.project-logo');

      setTimeout(() => {
        if(swiper.slides ){
 const activeSlideEl = swiper.slides[swiper.activeIndex];
        }
 const activeLogo = activeSlideEl.querySelector('.project-logo');
 if (activeLogo) {
   void activeLogo.offsetWidth;
   activeLogo.style.visibility = 'visible';
   activeLogo.classList.remove('opacity-0', 'pr-6');
   activeLogo.classList.add('opacity-100', 'pr-6');
 }
}, 50);

        if (titleRef.current) {
        //titleRef.current.stopRotation();
  }
    }}


      //onSwiper={(swiper) => console.log(swiper.activeIndex)}
    >
      {/* video-array */}
      {videosData.map((videoItem, index) => (
  <SwiperSlide className="opacity-0" key={`video-intro-${index + 1}`}>
    <div className="w-full h-[75vh] md:h-[100vh] relative overflow-hidden">
      <NavLink to={'/' + videoItem.taxo_slug + '/' + videoItem.slug}>
      <video
        ref={(el) => {
          // Store video references for slide change control
          if (el) {
            el.dataset.videoIndex = index;
          }
        }}
        className="homeVideo h-[75vh] md:h-[120vh] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 object-cover"

        //poster={index === 0 ? "/video/intro-poster.jpg" : undefined}
        autoPlay={index === 0} // Only first video autoplays
        muted
        loop
        playsInline
        preload="metadata"
        controls={false}
        webkit-playsinline="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        onLoadStart={(e) => {
          // Force play on iOS when loaded - only for first video
          if (index === 0) {
            e.target.play().catch(error => console.log('Autoplay prevented:', error));
          }
        }}
        onCanPlay={(e) => {
          // Ensure video plays as soon as it can - only for first video
          if (index === 0) {
            e.target.play().catch(err => console.log('Play failed:', err));
          }
        }}
      >
        <source src={videoItem.video_vimeo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Add the gradient overlay */}
      <div className="absolute bottom-0 left-0 w-full h-[28%] bg-gradient-to-t from-zinc-900 to-transparent pointer-events-none"></div>

     { videoItem.logo ?
        <div style={{visibility: 'hidden', transform: 'translateZ(0)', transition: 'padding 1s ease, opacity 0.8s ease'}} className={"fadeIn absolute bottom-28 md:bottom-28 right-1 md:right-2 opacity-0 pr-6 transform transition-all duration-500 delay-200  z-10 ease-out project-logo project-logo-" + index }><img className="w-[290px]" src={'https://discover.af-pictures.com/storage/app/media/' + videoItem.logo} alt="item.logo"/></div>
        : '' }

</NavLink>
    </div>
  </SwiperSlide>
))}


       : ''     ))  : '' */}
     </Swiper>
{/* TitleAnimatedRotated component disabled for this project */}
          <div style={{marginTop:-30+'px',transform: 'translateZ(0)', transition: 'opacity 0.6s ease, transform 0.6s ease'}} className={"w-full text-center fadeIn absolute right-[0] bottom-[0%] text-xl uppercase text-white opacity-100 z-10 ease-out" }>

            <div
        id="ttlRotate"
        className="w-full text-center inter-bold branding font-medium leading-6*2"
        style={{transform:'translateY(-10px)', transition: 'opacity 0.6s ease, transform 0.6s ease'}}
        dangerouslySetInnerHTML={{__html: currentSlideTitle }}
      />
            </div>


          </div>

          <div className="w-full p-8 bg-[#c00] center text-center">
            <Link to="/theclub" className="w-full block w-full">
              <h3 className="font-semibold w-full block text-3xl text-white w-full">ÚNETE AL CLUB AF</h3>
            <p className="font-regular w-full block text-xl text-white w-full max-w-[500px] mx-auto">
              Súmate a nuestra comunidad para recibir invitaciones a nuestros preestrenos, pases tests, sorteos </p>
              <p className="font-semibold text-xl">
                ¡y mucho más!
            </p>
          </Link>
          </div>

          {/* CONCURSO DE GUIONES */}
          <div className="w-full p-8 bg-[#735707] center text-center">
            <Link to="/concurso-guiones" className="w-full block w-full">
              <h3 className="font-semibold w-full block text-3xl text-white w-full">CONCURSO DE GUIONES</h3>
            <p className="font-regular w-full block text-xl text-white w-full max-w-[500px] mx-auto">
              ¿Estudias cine o audiovisuales? Presenta tu guion de cortometraje de terror y gana un premio de 3.000€ </p>
              <p className="font-semibold text-xl text-white">
                ¡Inscríbete aquí!
            </p>
          </Link>
          </div>


       {/* ESTRENOS */}
       <div className="pl-3 md:pl-10">
         <div id="estrenos" className="grid grid-cols-1 gap-1 pt-8">
           <div className="-flex items-end -justify-start py-4">
             <NavLink to="/estrenos" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }}>
               <h2 style={{fontSize:'1.6em',letterSpacing:'3px',borderTop:'1px solid #333',margin:'0 auto'}} className="text-6xl font-light text-center md:text-left px-4 md:pr-8 text-white pt-8 hover:opacity-80 transition-opacity cursor-pointer">
                 ESTRENOS
               </h2>
             </NavLink>
         </div>
        {/*    <div className="text-white flex items-end justify-end">
             <NavLink style={{paddingBottom:9+'px'}} to="./cine" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }} className="inline-flex pr-4 mr-1 md:pr-12 items-center">
                 + Cine
               </NavLink>
         </div>
          */}
         </div>



       <div className="w-full py-0 bg-zinc-900 center relative">
               <div className="overflow-x-auto whitespace-nowrap">
                 <ColoredScrollbars className="scrollDarkBg barScroll_1" style={{ height: 480 }}>
                 {projectsLaunch.length > 0 ? projectsLaunch.map((project,index) => (
                 index < 20 ?

                 <div className={'grow inline-block w-[238px] text-white  mx-0.5 items-center justify-center text-md font-medium grow-cine-' + index} key={'doc-'+ index}>

                     <a className="w-full" href={'/estrenos/'+project.slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }}>

                     <picture id={'btn-cine-' + index} className="link">
                     <ProgressiveImageImg
                     src={project.image_thumb.url}
                     placeholder={'/static/trans.gif'}
                     modal={theme.modal}
                     bg={'#333'}
                     imgMargin={props.imgMargin}
                     />
                     </picture>

                     <div className="flex flex-col p-1 space-y-1 text-left text-white">
                         <p style={{fontSize:110+'%'}} className="notranslate font-medium pb-2 pt-3 text-wrap">{project.name}</p>
                     </div>

                   </a>

                 </div>

                  : ''     ))  : ''}
              </ColoredScrollbars>
               </div>
              {/* <div className="text-center px-4 mb-4 space-x-0 md:space-x-2 md:mb-8 text-white">
                 <NavLink to="./cine"state={{ from: 'home', backLink:'cine' }} className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-md  sm:w-auto sm:mb-0 pt-2">
                     Ver m&aacute;s Cine
                     <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                   </NavLink>
               </div> */}
               <button className="ml-2 top-[50%] button-prev text-white" onClick={() => {
                 const el = document.querySelector('.grow-cine-0');
                 const _w = el?.getBoundingClientRect().width + 8;


                 const view = document.querySelector('.barScroll_1 .view');
                if (view) {
                    view.scrollBy({ left: -_w, behavior: 'smooth' });
                }
               }
             }>
                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
                   <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                 </svg>
               </button>

               <button className="mr-2 top-[50%] button-next text-white" onClick={() => {
                 const el = document.querySelector('.grow-cine-0');
                 const _w = el?.getBoundingClientRect().width + 8;


                 const view = document.querySelector('.barScroll_1 .view');
                if (view) {
                    view.scrollBy({ left: _w, behavior: 'smooth' });
                }
               }
             }>
                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
                   <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                 </svg>
               </button>
       </div>
</div>


<div className="pl-3 md:pl-10">
  {projectsCat.length > 0 ?
  <div id="catalogo" className="grid grid-cols-1 gap-1 pt-8">
    <div className="-flex items-end -justify-start py-4">
      <NavLink to="/catalogo" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }}>
        <h2 style={{fontSize:'1.6em',letterSpacing:'3px',borderTop:'1px solid #333',margin:'0 auto'}} className="text-6xl font-light text-center md:text-left px-4 md:pr-8 text-white pt-8 hover:opacity-80 transition-opacity cursor-pointer">
          PELÍCULAS EN CATÁLOGO
        </h2>
      </NavLink>
  </div>

  </div>
  : '' }


{projectsCat.length > 0 ?
<div className="w-full py-0 bg-zinc-900 center relative">
        <div className="overflow-x-auto whitespace-nowrap">
          <ColoredScrollbars className="scrollDarkBg barScroll_2" style={{ height: 480 }}>
          {projectsCat.length > 0 ? projectsCat.map((project,index) => (
          index < 20 ?

          <div className={'grow inline-block w-[238px] text-white  mx-0.5 items-center justify-center text-md font-medium grow-cine-' + index} key={'doc-'+ index}>

              <a className="w-full" href={'/catalogo/'+project.slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }}>

              <picture id={'btn-cine-' + index} className="link">
              <ProgressiveImageImg
              src={project.image_thumb.url}
              placeholder={'/static/trans.gif'}
              modal={theme.modal}
              bg={'#333'}
              imgMargin={props.imgMargin}
              />
              </picture>

              <div className="flex flex-col p-1 space-y-1 text-left text-white">
                  <p style={{fontSize:110+'%'}} className="notranslate font-medium pb-2 pt-3 text-wrap">{project.name}</p>
              </div>

            </a>

          </div>

           : ''     ))  : ''}
       </ColoredScrollbars>
        </div>
       {/* <div className="text-center px-4 mb-4 space-x-0 md:space-x-2 md:mb-8 text-white">
          <NavLink to="./cine"state={{ from: 'home', backLink:'cine' }} className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-md  sm:w-auto sm:mb-0 pt-2">
              Ver m&aacute;s Cine
              <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
            </NavLink>
        </div> */}
        <button className="ml-2 top-[50%] button-prev text-white" onClick={() => {
          const el = document.querySelector('.grow-cine-0');
          const _w = el?.getBoundingClientRect().width + 8;


          const view = document.querySelector('.barScroll_2 .view');
         if (view) {
             view.scrollBy({ left: -_w, behavior: 'smooth' });
         }
        }
      }>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
        </button>

        <button className="mr-2 top-[50%] button-next text-white" onClick={() => {
          const el = document.querySelector('.grow-cine-0');
          const _w = el?.getBoundingClientRect().width + 8;


          const view = document.querySelector('.barScroll_2 .view');
         if (view) {
             view.scrollBy({ left: _w, behavior: 'smooth' });
         }
        }
      }>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>
        </button>
</div>
: '' }
</div>


 <div className="pl-3 md:pl-10 w-full fadeIn">
         <div id="servicios" className="grid grid-cols-2 gap-1 py-4 pt-8">

        {/*    <div className="text-white flex items-end justify-end">
             <NavLink style={{paddingBottom:9+'px'}} to="./cine" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }} className="inline-flex pr-4 mr-1 md:pr-12 items-center">
                 + Cine
               </NavLink>
         </div>
          */}
         </div>
         <div className="col-span-2 w-full text-white mt-8 pb-8">
              <div className="px-12 mx-auto max-w-7xl"><div className="w-full mx-auto text-center md:w-11/12 xl:w-9/12">
                <h1 style={{fontWeight:'100!important'}} className="mb-8 text-4xl font-light! leading-none text-white md:text-6xl "><span>Connecting Audiences <br/>with</span> <span className="block w-full py-2 leading-12 branding lg:inline"> Motion Pictures</span></h1>

                  <div className="px-0 mb-8 text-lg text-gray-100 md:text-xl lg:px-24" dangerouslySetInnerHTML={{__html: about[0] }}/>

                {/* <div className="mb-4 space-x-0 md:space-x-2 md:mb-8"><a className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-lg text-white bg-branding rounded-2xl sm:w-auto sm:mb-0" href="/catalogo">Películas en catalogo<svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg></a>
                <!-- <a className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-lg rounded-2xl sm:w-auto sm:mb-0" href="/contacto">Contacto<svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg></a>//-->
                </div>*/}

            </div></div>
            </div>
         </div>

{/* Contact */}
<div style={{background: 'linear-gradient(to bottom, rgba(40, 39, 34, 0.8), transparent)'}} className="py-16 opacity-0 fadeIn">
<Contact/>
</div>

{/* Map */}
<iframe style={{opacity:60,border:0,filter: 'invert(90%) hue-rotate(180deg)'}}  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3037.205090330246!2d-3.67423742378162!3d40.426457355046814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd4228b0624513c1%3A0x8dd791266fae2402!2sC.%20Alcal%C3%A1%2C%20126%2C%20Salamanca%2C%2028009%20Madrid!5e0!3m2!1sen!2ses!4v1756671490081!5m2!1sen!2ses" width="600" height="450" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>

</section>
    </>
  )
}

export default Home
